<template>
  <!-- Root keeps `group` for `group-has-[…]` rules in HorizontalAccordionItemTitle / Content. -->
  <div class="group border-b py-4 last:border-b-0">
    <slot></slot>
  </div>
</template>
